import angular from 'angular';
import '../resources/group';

const module = angular.module('whyline.services.group', [
  'whyline.resources.group'
]);

let Group;
const socketEvents = {
  create: 'group:created',
  update: 'group:updated',
  deleted: 'group:deleted',
  clear: 'group:clear',
};
class GroupService {

  static $inject = ['Group'];

  constructor(injectedGroup) {
    Group = injectedGroup;
  }

  GetAll() {
    return Group.FetchAll();
  }

  GetAllFromServer() {
    return Group.FetchAll({force: true});
  }

  GetAllGroups() {
    return Group.GetAllGroups();
  }

  GetAllAsPromise() {
    return Group.FetchAll({ promise: true });
  }

  GetAllAsPromiseFromServer() {
    return Group.FetchAll({ promise: true, force: true});
  }

  GetOne(groupId) {
    return Group.FindById(groupId);
  }

  GetOneFromServer(groupId) {
    return Group.FindById(groupId, {force: true});
  }

  GetOneAsPromiseFromServer(groupId) {
    return Group.FindById(groupId, {promise: true, force: true});
  }

  GetOneAsPromise(groupId) {
    return Group.FindById(groupId, {promise: true});
  }

  GetOneById(groupId) {
    return Group.GetOneById(groupId);
  }

  GetMyGroupsAsPromiseFromServer() {
    return Group.GetMyGroups({ promise: true, force: true });
  }

  GetAllForNowServing() {
    return Group.GetAllForNowServing();
  }

  CallNext(groupId) {
    return Group.CallNext(groupId);
  }

  CallTo(subscriptionId, groupId) {
    return Group.CallTo(subscriptionId, groupId);
  }

  Update(groupUpdate) {
    return Group.Update(groupUpdate);
  }
}

module.exports = module.service('GroupService', GroupService);